/* eslint-disable react-hooks/exhaustive-deps */
import imageError from "@assets/images/payment-failed-icon.svg";
import { Direction } from "@common/constans";
import { CabinClass, FlightPoint, IAirCheckinBoardingPass, IAirCheckinRequest, IOriginDestination, ITraveler, Locality } from "@common/models";
import { IShareInitializeResponse } from "@common/models/ShareInitializeResponse";
import BoardingPassPrint from "@components/checkIn/BoardingPassPrint";
import FlightRoute from "@components/checkIn/FlightRoute";
import SeatMap from "@components/checkIn/SeatMap";
import Divider from "@components/general/Divider";
import Icon from "@components/general/Icon";
import Navigation from "@components/general/Navigation";
import { Culture } from "@core/index";
import { AppAction, IAppAction } from "@misc/Action";
import { IAppState } from "@misc/State";
import { Action, getBoardingPass as boardingPassApiCall, getTripTrackLink } from "@service/proxy";
import Translate from "@service/Translate";
import { formatToDate, getAirport, minToMinHour } from "@utilize/Format";
import { getPrint } from "@utilize/Window";
import bwipjs from 'bwip-js';
import { FC, useEffect, useRef, useState } from "react";
import ContentLoader from "react-content-loader";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import Sharing from "./Sharing";
import { Weather } from "@components/weather/Weather";
import { ICity } from "@common/models/CMS";
interface IBoardingPassProps { };


const BoardingPass: FC<IBoardingPassProps> = () => {
    const { tr } = Translate;
    const dispatch = useDispatch();
    const dateTime = Culture.getDateTimeInstance();
    const { fleets, errors } = useSelector((state: IAppState) => ({
        fleets: state.fleets,
        errors: state.errors,
        width: state.windowWidth
    }));
    const [loading, setLoading] = useState<boolean>(false);
    const [shareInitializeResponse, setShareInitializeResponse] = useState<IShareInitializeResponse>();
    const [boardingPass, setBoardingPass] = useState<IAirCheckinBoardingPass>();
    const welcomeRef = useRef<HTMLDivElement>(null);
    const passengerNameRef = useRef<HTMLDivElement>(null);
    const query = new URLSearchParams(useLocation().search);
    const flightNumber = query.get("flight") || "";
    const referenceId = query.get("ticket") || "";
    const passengerId = query.get("id") || "";
    const flightSegment = boardingPass?.originDestination?.flightSegments?.length ? boardingPass?.originDestination?.flightSegments[0] : {};
    const now = dateTime.getTime() - (dateTime.getTimezoneOffset() * 60 * 1000);
    const remainingToTakeof = Math.floor(((boardingPass?.originDestination?.departureDateTime || 0) - now) / 60_000);
    const traveler = boardingPass?.traveler || {}
    const seatNumber = traveler.tickets?.length ? traveler.tickets[0].seatNumber : "";
    const travelers: ITraveler[] = [];
    //Push traveler and infant to travelers
    if (traveler.refNumber)
        travelers.push(traveler)
    if (boardingPass?.infant?.refNumber)
        travelers.push(boardingPass.infant);

    useEffect(() => {
        getBoardingPass();
    }, []);

    useEffect(() => {
        if (boardingPass) {
            const seatMap = document.getElementById("seatMap") as HTMLElement;
            const seatMapBody = document.getElementById("seatMapBody") as HTMLElement;
            if (seatMap && seatMapBody && seatMapBody.getBoundingClientRect().width > window.innerWidth)
                seatMap.style.right = `-${((window.innerWidth - 170) / 2) - 10}px`;
        }
    }, [boardingPass]);

    const getBoardingPass = () => {
        boardingPassApiCall(Action.POST, { data: { flightNumber, referenceId, passengerId } })
            .then((response) => {
                const boardingPass = response.content;
                dispatch<IAppAction>({ type: AppAction.SeatMap, payload: { seatMap: boardingPass.seatMap } });
                dispatch<IAppAction>({ type: AppAction.AirCheckinInfo, payload: { airCheckinInfo: { originDestination: boardingPass.originDestination } } });
                dispatch<IAppAction>({ type: AppAction.AirCheckinSelectedTravelers, payload: { airCheckinSelectedTravelers: [boardingPass.traveler || {}] } });
                setBoardingPass(boardingPass);
                try {
                    bwipjs.toCanvas('pdf417TravelerScanner', {
                        bcid: 'pdf417',
                        text: (boardingPass.traveler?.tickets?.length && boardingPass.traveler.tickets[0].keyBoarding) || "",
                        scale: 3,
                        height: 5,
                        width: 36,
                        includetext: true,
                        textxalign: 'center',
                    });
                    if (boardingPass.infant)
                        bwipjs.toCanvas('pdf417InfantScanner', {
                            bcid: 'pdf417',
                            text: (boardingPass.infant?.tickets?.length && boardingPass.infant.tickets[0].keyBoarding) || "",
                            scale: 3,
                            height: 5,
                            width: 36,
                            includetext: true,
                            textxalign: 'center',
                        });

                } catch (e) {
                    console.log(e);
                }
            })
            .catch((err) => {
                dispatch<IAppAction>({ type: AppAction.Errors, payload: { errors: err.messages || [] } });
            })
            .finally(() => {
                welcomeRef.current?.classList.add("animate");
                setTimeout(() => {
                    welcomeRef.current?.classList.remove("animate");
                    passengerNameRef.current?.classList.add("animate");
                }, 3000);
            })
    }

    const onShareBoardingPassInit = () => {
        const shortenLinkRequest: IAirCheckinRequest = {
            flightNumber: flightNumber,
            referenceId: referenceId,
            passengerId: traveler.refNumber
        }
        getTripTrackLink(Action.POST, { data: shortenLinkRequest })
            .then((response) => {
                setShareInitializeResponse(response.content);
                setLoading(true);
            })
            .catch((error) => { })
    }

    const cityCode = boardingPass?.originDestination?.destination.code || '';
    const city: ICity = {
        code: { code: cityCode },
        forecaWeatherId: getAirport(cityCode).forecaWeatherId,
        name: getAirport(cityCode).cityName
    }

    return (
        errors.length ?
            <main className="boarding-pass error">
                <article className="boarding-pass-title">
                    <img src={imageError} alt="imageError" />
                    {errors?.map((error, index) => <span key={index}>{tr(error.code)}</span>)}
                </article>
            </main> :
            <div className={`boarding-pass${boardingPass?.originDestination?.locality === Locality.International ? " international" : ""}`}>
                <section className="boarding-pass-section">
                    <div className="boarding-pass-title">
                        {boardingPass && <Icon name="icon-print" onClick={() => getPrint()} />}
                        <div className="boarding-pass-title-container">
                            <span ref={welcomeRef} className="boarding-pass-welcome">{tr("boarding_pass_bon_voyage")}</span>
                            <span ref={passengerNameRef} className="en boarding-pass-passenger-name trim">{boardingPass ? `${traveler.firstName} ${traveler.lastName}` : renderLoading().header}</span>
                        </div>
                        {boardingPass && <Icon name="icon-share" onClick={() => onShareBoardingPassInit()} />}
                    </div>
                    <div className="boarding-pass-content" style={{ minHeight: `${window.innerHeight - 85}px` }}>
                        <div className="text-center">
                            {boardingPass ? <canvas id="pdf417TravelerScanner" className="pdf417-traveler-scanner" /> : renderLoading().barcode}
                        </div>
                        {
                            boardingPass?.infant ?
                                <>
                                    <Divider mode="perforation" orientation="horizontal" />
                                    <div className="def-pad">
                                        <div className="flex align-center">
                                            <Icon name="icon-compeer-infant" />
                                            <span>{tr("compeer_infant")}</span>
                                        </div>
                                        <div className="boarding-pass-infant-name">
                                            <span className="ltr en">{`${boardingPass?.infant?.firstName} ${boardingPass?.infant?.lastName}`}</span>
                                        </div>
                                        <div className="text-center">
                                            <canvas id="pdf417InfantScanner" />
                                        </div>
                                    </div>
                                </>
                                :
                                ""
                        }
                        <Divider mode="perforation" orientation="horizontal" />
                        <div className="def-pad">
                            <div className="flight-information">
                                <FlightRoute flightSegment={boardingPass?.originDestination?.flightSegments[0] || {}} />
                            </div>
                        </div>
                        <div className="flight-number-container">
                            <div className="flight-number">
                                <Icon name="icon-circular" />
                            </div>
                            <span className="flight-number-txt owner en">{boardingPass ? flightSegment.owner : renderLoading().numberBox}</span>
                            <span className="flight-number-txt number en">{boardingPass ? flightSegment.flightNumber?.replace("W5", "") : renderLoading().stringBox}</span>
                            <Divider mode="perforation" orientation="horizontal" />
                        </div>
                        <div className="boarding-pass-date def-pad">
                            <div>{tr('flight_date')}</div>
                            <div style={{ fontWeight: "bold" }}>{boardingPass ? formatToDate(boardingPass?.originDestination?.departureDateTime || 0, { format: "l d M Y" }) : renderLoading().longStringBox}</div>
                        </div>
                        <div className="flight-seat-map">
                            <div className="text-center minimal-seat-map">
                                {boardingPass ? <SeatMap miniMode /> : renderLoading().seatMap}
                            </div>
                            <div className="flex minimal-seat-map-detail def-pad">
                                <div className="seat-number en">
                                    <Icon name="icon-seat-up-view" />
                                    <span className={`seat-number-value ${!boardingPass && 'loading'}`}>{seatNumber ? seatNumber : renderLoading().seatNumber}</span>
                                </div>
                                <div className="row flex align-center additional-flight-info">
                                    <div className="col-1-1 flex align-center justify-between">
                                        <div className="flight-info-title">{tr("calss_of_service")}</div>
                                        <div className="flight-info-desc">{boardingPass ? tr(`cabin_class_${CabinClass[boardingPass?.originDestination?.classOfService || 0].toLowerCase()}`) : renderLoading().stringBox}</div>
                                    </div>
                                    <div className="col-1-1 flex align-center justify-between">
                                        <div className="flight-info-title">{tr("aircraft_model")}</div>
                                        <div className="flight-info-desc">{boardingPass ? fleets.find(f => f.code?.code?.toLowerCase() === flightSegment.equipmentModelInfo?.toLowerCase())?.displayText : renderLoading().stringBox}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Divider mode="perforation" orientation="horizontal" />
                        <div className="flex align-center justify-between def-pad">
                            {boardingPass ?
                                remainingToTakeof > 0 ?
                                    <div className="flex align-center">
                                        <Icon name="icon-restore-clock" />
                                        <span>{tr("boarding_pass_remaining_to_takeoff", minToMinHour(remainingToTakeof))}</span>
                                    </div>
                                    :
                                    <div>{tr("routing_to", "airport")}</div> : renderLoading().longStringBox
                            }
                            {
                                boardingPass ? <Navigation
                                    variant="contained"
                                    color="primary"
                                    text={tr("routing")}
                                    icon="icon-airport-departure"
                                    width="115px"
                                    height="35px"
                                    target="_blank"
                                    location={
                                        {
                                            lat: new FlightPoint(flightSegment.origin!).getDefaultTerminal(Direction.Departure, flightSegment.destination?.code || "")?.location?.latitude ?? getAirport(flightSegment.origin?.code).latitude!,
                                            lng: new FlightPoint(flightSegment.origin!).getDefaultTerminal(Direction.Departure, flightSegment.destination?.code || "")?.location?.longitude! ?? getAirport(flightSegment.origin?.code).longitude!
                                        }
                                    }
                                /> : renderLoading().button
                            }
                        </div>
                        <Divider mode="perforation" orientation="horizontal" />
                        <div className="def-pad">
                            <Weather
                                city={city}
                                daysCount={3}
                            />
                        </div>
                    </div>
                    <Sharing
                        show={loading}
                        shareInitializeResponse={shareInitializeResponse}
                        selfSharing
                        onCloseClick={() => setLoading(false)}
                    />
                </section>
                <BoardingPassPrint travelers={travelers} originDestination={boardingPass?.originDestination || {} as IOriginDestination} />
            </div>
    )
}

export const renderLoading = () => ({
    coverElement: <ContentLoader width="100%" height="100%">
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
    </ContentLoader>,
    stringBox: <ContentLoader width="50px" height="15px">
        <rect x="0" y="0" rx="8px" ry="8px" width="100%" height="100%" />
    </ContentLoader>,
    longStringBox: <ContentLoader width="150px" height="15px">
        <rect x="0" y="0" rx="8px" ry="8px" width="100%" height="100%" />
    </ContentLoader>,
    numberBox: <ContentLoader width="20px" height="15px">
        <rect x="0" y="0" rx="8px" ry="8px" width="100%" height="100%" />
    </ContentLoader>,
    seatMap: <ContentLoader width="calc(100% - 10px)" height="170px">
        <rect x="0" y="0" rx="15px" ry="15px" width="100%" height="100%" />
    </ContentLoader>,
    seatNumber: <ContentLoader width="50px" height="50px">
        <rect x="0" y="0" rx="20%" ry="20" width="100%" height="100%" />
    </ContentLoader>,
    header: <ContentLoader width="100%" height="35px" backgroundColor="#00a693" foregroundColor="#108678ba">
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
    </ContentLoader>,
    button: <ContentLoader width="115px" height="35px">
        <rect x="0" y="0" rx="8px" ry="8px" width="100%" height="100%" />
    </ContentLoader>,
    squareButton: <ContentLoader width="35px" height="35px">
        <rect x="0" y="0" rx="8px" ry="8px" width="100%" height="100%" />
    </ContentLoader>,
    barcode: <ContentLoader width="280px" height="48px">
        <rect x="0" y="0" rx="8px" ry="8px" width="100%" height="100%" />
    </ContentLoader>
})

export default BoardingPass;

